export default {
  title: 'طرف‌های پرداخت (Payees)',
  hubBadge: 'خزانه‌داری و طرف‌های پرداخت',
  hubDescription: 'مدیریت اشخاص، کارمندان، تأمین‌کنندگان و حساب‌های دریافت‌کننده وجه برای ثبت اسناد پرداخت نقدی.',
  tabs: {
    all: 'همه دریافت‌کنندگان',
    vendor: 'فروشندگان و تأمین‌کننده',
    employee: 'کارمندان و پرسنل',
    other: 'طرف‌های سایر (Other)',
  },
  filters: {
    searchPlaceholder: 'جستجوی نام دریافت‌کننده، شرکت یا تلفن...',
    crmStatus: 'وضعیت در CRM',
    activeOnly: 'فقط فعال‌ها',
    disabledOnly: 'غیرفعال‌ها',
  },
  columns: {
    seq: '#',
    name: 'نام دریافت‌کننده (Payee Name)',
    nameFa: 'نام فارسی / دری',
    type: 'دسته‌بندی (Type)',
    contact: 'اطلاعات تماس (Contact)',
    qboId: 'شناسه QBO',
    branch: 'نمایندگی (Branch)',
    allBranches: 'همه نمایندگی‌ها',
    active: 'وضعیت در CRM',
    actions: 'عملیات',
  },
  types: {
    employee: 'کارمند (Employee)',
    vendor: 'فروشنده / تأمین‌کننده (Supplier)',
    other: 'طرف سایر (Other)',
  },
  actions: {
    sync: 'همگام‌سازی از QBO',
    syncing: 'در حال همگام‌سازی…',
    add: 'افزودن Payee / سایر',
    edit: 'ویرایش',
  },
  dialog: {
    createTitle: 'افزودن دریافت‌کننده',
    createDescription: 'افزودن شخص یا طرف حساب جدید برای ثبت اسناد پرداخت.',
    editTitle: 'ویرایش دریافت‌کننده',
    editDescription: 'ویرایش مشخصات و اطلاعات تماس دریافت‌کننده.',
    nameLabel: 'نام لاتین / اصلی',
    namePlaceholder: 'نام دریافت‌کننده...',
    nameFaLabel: 'نام فارسی / دری',
    nameFaPlaceholder: 'نام فارسی...',
    typeLabel: 'نوع / دسته‌بندی',
    companyLabel: 'شرکت / سازمان',
    companyPlaceholder: 'اختیاری...',
    phoneLabel: 'شماره تماس',
    emailLabel: 'ایمیل',
    branchLabel: 'نمایندگی در CRM',
    branchPlaceholder: 'انتخاب نمایندگی (اختیاری)',
    noSpecificBranch: 'همه نمایندگی‌ها (بدون محدودیت)',
    notesLabel: 'یادداشت',
    notesPlaceholder: 'اختیاری...',
    qboAccountLabel: 'حساب مرتبط در کویک‌بوکس',
    qboAccountPlaceholder: 'انتخاب حساب (اختیاری)',
    noSpecificAccount: 'بدون اتصال',
    activeLabel: 'وضعیت در CRM',
    activeDesc: 'فعال بودن کلی این طرف حساب در سیستم',
    formVisibility: 'نمایش در فورم‌ها',
    allowedInVoucher: 'سند پرداخت (Payment Voucher)',
    allowedInVoucherDesc: 'این دریافت‌کننده در سند پرداخت نمایش داده شود',
    allowedInExpenseReport: 'گزارش مصارف (Expense Report)',
    allowedInExpenseReportDesc: 'این دریافت‌کننده در فورم گزارش مصارف نمایش داده شود',
    optional: 'اختیاری',
    cancel: 'انصراف',
    save: 'ذخیره',
    saving: 'در حال ذخیره…',
  },
  messages: {
    syncSuccess: 'همگام‌سازی موفق ✓',
    syncSuccessDesc: 'طرف‌های پرداخت با موفقیت از کویک‌بوکس همگام‌سازی شدند.',
    syncError: 'خطا در همگام‌سازی طرف‌های پرداخت',
    createSuccess: 'دریافت‌کننده ایجاد شد ✓',
    createSuccessDesc: 'با موفقیت به لیست دریافت‌کنندگان اضافه شد.',
    updateSuccess: 'مشخصات به‌روزرسانی شد ✓',
    updateSuccessDesc: 'اطلاعات با موفقیت ذخیره گردید.',
    saveFailed: 'خطا در ذخیره دریافت‌کننده',
    validationError: 'خطای اعتبارسنجی',
    nameRequired: 'نام نمایشی دریافت‌کننده الزامی است.',
    loadError: 'خطا در بارگذاری طرف‌های پرداخت',
    statusUpdated: 'وضعیت در CRM تغییر یافت.',
  },
};
